<template>
   <div >
		  <div v-if="is_click" class="switch clearfix" @click.stop="toggle"
				v-bind:style="{ background: activeState ? activeColor : inActiveColor }">
				 <div v-show="activeState" class="switch-text switch-on"  transition="switchOn"></div>
				 <div class="switch-icon icon_active" v-if="activeState" >{{$t('ifttt.openSwitch')}}</div>
				 <div class="switch-icon icon_inactive" v-else>{{$t('ifttt.closeSwitch')}}</div>
					 <div v-show="!activeState" class="switch-text switch-off"></div>
			</div>
			 <div v-else class="switch clearfix"
				v-bind:style="{ background: activeState ? activeColor : inActiveColor }">
				 <div v-show="activeState" class="switch-text switch-on"  transition="switchOn"></div>
				 <div class="switch-icon icon_active" v-if="activeState" >{{$t('ifttt.open')}}</div>
				 <div class="switch-icon icon_inactive" v-else>{{$t('ifttt.close')}}</div>
					 <div v-show="!activeState" class="switch-text switch-off"></div>
			</div>
	 </div>


</template>

<script>
 export default {
  props: {
		 is_click: {
		  Type: Boolean,
		  default: true  //是否可点击
		 },
    active: {
      Type: Boolean,
      default: false  //是否选中
     },
     activeColor: {
       Type: String,
       default: '#67c23a' //选中颜色
     },
     inActiveColor: {
       Type: String,
       default: '' //默认颜色
     }
   },
   data () {
     return {
       activeState: this.active
     }
   },
   methods: {
		 /* 自动化列表 开关组件 点击 将值传给调用的页面
		 */
    toggle () {
       this.activeState = !this.activeState;
			 this.$emit('changeswitch',this.activeState);
     }
  }
 }
</script>

<style lang="scss" scoped>
/* 	switch开关组件 */
 .switch{
   display: inline-block;
   border-radius: 15px;
   box-sizing: border-box;
   border: 1px solid #c6d2ed;
   overflow: hidden;
   cursor: pointer;
   & > div{
     float: left;
   }
   .switch-text{
     height: 24px;
     line-height: 24px;
     color: #ffffff;
     font-size: 14px;
     padding: 0 20px;
  }
   .switch-icon{
     width: auto;
     min-width: 24px;
     height: 24px;
     border-radius: 50%;
     background-color: #ffffff;
     border: 1px solid #dcdcdc;
     margin: 1px;
	 font-size: 12px;
	 line-height: 24px;
	 text-align: center;
   }
   .icon_active{
	   color: #67c23a;
	   background: #ddf6d2;
   }
   .icon_inactive{
	   color: #7b7b7b;
   }
 }
</style>
